import { KortbetjeningText } from '@hooks/use-text';

enum DigitalCardError {
    GENERIC_ERROR = 'GENERIC_ERROR',
    INVALID_CARD = 'INVALID_CARD',
    NETS_COMMUNICATION_ERROR = 'NETS_COMMUNICATION_ERROR',
}

const errorNameMap = {
    [DigitalCardError.GENERIC_ERROR]: 'digitalCardFetchError',
    [DigitalCardError.INVALID_CARD]: 'digitalCardInvalidCardError',
    [DigitalCardError.NETS_COMMUNICATION_ERROR]: 'digitalCardNetsCommunicationError',
};

const getErrorSitecoreKey = (errorName: string): string => {
    if (typeof errorNameMap[errorName] === 'undefined') {
        return errorNameMap[DigitalCardError.GENERIC_ERROR];
    }

    return errorNameMap[errorName];
};

const getPrettyError = (error: Error | null, text: KortbetjeningText) => {
    if (error === null) {
        return text.digitalCardFetchError;
    }

    const sitecoreKey = getErrorSitecoreKey(error.name);

    if (typeof text[sitecoreKey] === 'undefined') {
        return text.digitalCardFetchError;
    }

    return text[sitecoreKey];
};

export default getPrettyError;
